import { jsx as _jsx } from "react/jsx-runtime";
function IconStarFilled(props) {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconStarFilled", ...props, children: _jsx("path", { d: "M6.05 21.19l.91-6.552-4.589-4.766 6.514-1.16L12 2.877l3.115 5.837 6.513 1.159-4.588 4.766.91 6.553L12 18.299l-5.95 2.892z", fill: "currentColor" }) }));
}
export default IconStarFilled;
//# sourceMappingURL=IconStarFilled.js.map